export default "__VITE_ASSET__sXnPTG8k__"